import React from 'react';
import { useSelector } from 'react-redux';
import {
    getVersionGenealogy,
} from '../../../Domain/Scene/Builder/VersionHistoryService';
import 'Application/Templates/Css/Layer/VersionHistory.css';

const isAngle = (type) => ['torque', 'tip', 'rotation'].includes(type);

const formatValue = (value, type) => {
    if (value === null || value === undefined) return '-';
    if (isAngle(type)) {
        return `${parseFloat(value).toFixed(1)}°`;
    }

    return (
        <>
            {parseFloat(value).toFixed(2)}
            <span className="vh-unit-mm">mm</span>
        </>
    );
};

const isValidAuthor = (author) =>
    author && author !== 'unknown' && author !== 'Unknown';

const getVersionDisplayNumberMap = (versionOptions) => {
    const map = new Map();

    (versionOptions || []).forEach((option) => {
        if (!option || option.value === '' || option.value === -1 || option.disabled) return;
        const match = String(option.label || '').match(/(\d+)\s*$/);
        if (!match) return;
        map.set(option.value, parseInt(match[1], 10));
    });

    return map;
};

const ToothBlock = ({ toothId, movements }) => (
    <div className="vh-tooth">
        <div className="vh-tooth-id">{toothId}</div>
        <div className="vh-tooth-movements">
            {Object.entries(movements).map(([type, value]) => (
                <div key={type} className="vh-movement-row">
                    <span className="vh-movement-type">{type}</span>
                    <span className="vh-movement-value">{formatValue(value, type)}</span>
                </div>
            ))}
        </div>
    </div>
);

const VersionGroup = ({ version, isCurrent, displayVersionNumber }) => {
    const toothEntries = Object.entries(version.movementHistory || {});

    return (
        <div className={`vh-version-group${isCurrent ? ' vh-version-current' : ''}`}>
            <div className={`vh-version-group-label${version.deleted ? ' vh-version-deleted' : ''}`}>
                v{displayVersionNumber ?? version.versionNumber}
                {isValidAuthor(version.author) && (
                    <span className="vh-version-author"> · {version.author}</span>
                )}
            </div>
            <div className="vh-version-teeth">
                {toothEntries.length > 0 ? toothEntries.map(([toothId, movements]) => (
                    <ToothBlock key={toothId} toothId={toothId} movements={movements} />
                )) : <span className="vh-no-movements">—</span>}
            </div>
        </div>
    );
};

export const VersionHistoryPanel = () => {
    const selectedVersion = useSelector(s => s.ViewportReducer.selectedVersion);
    const versionOptions = useSelector(s => s.ViewportReducer.versions);
    const modifications = useSelector(s => s.ViewportReducer.modifications);

    if (!modifications || selectedVersion === -1) {
        return <div className="vh-empty">Aucun historique disponible.</div>;
    }

    // genealogy[0] = current, [1] = parent, etc.
    const genealogy = getVersionGenealogy(modifications, selectedVersion);
    const displayNumberMap = getVersionDisplayNumberMap(versionOptions);

    if (!genealogy.length) {
        return <div className="vh-empty">Aucun historique disponible.</div>;
    }

    return (
        <div className="vh-panel">
            <div className="vh-teeth-row">
                <span className="vh-arrow vh-arrow-setup">setup</span>
                {[...genealogy]
                    .reverse()
                    .map((version, index, arr) => (
                    <React.Fragment key={version.id}>
                        <span className="vh-arrow">→</span>
                        <VersionGroup
                            version={version}
                            isCurrent={index === arr.length - 1}
                            displayVersionNumber={displayNumberMap.get(version.id)}
                        />
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default VersionHistoryPanel;
